const colors = {
	main: '#093fd1',
} as const;

export default colors;